import { getEnvVar } from '../envUtils.ts';
import ApiService from "./ApiService";
import { v4 as uuidv4 } from "uuid";
// import { BASE_APP_URL } from "./ApiService";

const createTrueTwin = (data) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin`, data);
};
const deployTrueTwin = (truetwinId, data) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${truetwinId}/deploy`, data);
};

const unDeployTrueTwin = (truetwinId, data) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${truetwinId}/undeploy`, data);
};

const getAllTrueTwins = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin`);
};
const get_TrueTwins_by_satId = (sat_Id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin?satId=${sat_Id}`);
};

const getRemoteConfigData = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/remoteconfigdetails`);

}

const delete_TrueTwin = (trueTwinId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${trueTwinId}`);
};

const delete_Task = (taskId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task?taskId=${taskId}`);
}
const delete_Schedule = (sechduleId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}schedule?scheduleId=${sechduleId}`);
}

const postJSONCommand = (missionId, satId, jsonData, format) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/test-run?missionId=${missionId}&satId=${satId}&sequenceFormat=${format}`, jsonData);
}
const getJSONResponse = (testId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/test-run/${testId}/status`);
}

const getObject = (trueTwinId, customTc = false) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/test-case?trueTwinId=${trueTwinId}&customTc=${customTc}`);
}


const connectGroundStation = (gsId, truetwinId, scenario_id) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/connect?groundStationId=${gsId}&truetwinId=${truetwinId}&scenarioId=${scenario_id}`);
}

const removeGroundStation = (gsId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation?groundStationId=${gsId}`);
}

const runSequence = (gsId, format, truetwinId, scenario_id, bandType, type, data) => {
  if ((bandType === null) || (bandType === undefined)) {
    bandType = ""
  }
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/runsequence?groundStationId=${gsId}&sequenceFormat=${format}&trueTwinId=${truetwinId}&scenarioId=${scenario_id}&linkId=${bandType}&mode=${type}`, data);
}

const disconnectGroundStation = (gsId, truetwinId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/disconnect?groundStationId=${gsId}&truetwinId=${truetwinId}`);
}

const downloadSessionLogs = (trueTwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${trueTwinId}/techsupport`);
}
const createConsoleSession = (truetwinId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/CreateConsoleSession?truetwinId=${truetwinId}`);
}
const removeConsoleSession = (truetwinId) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/StopConsoleSession?truetwinId=${truetwinId}`);
}
const getConsoleSessionLogs = (truetwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/GetSessionList?truetwinId=${truetwinId}`);
}
const deleteConsoleSessionLogs = (truetwinId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/DeleteSession?truetwinId=${truetwinId}`);
}

const createDataStoreTT = (truetwinId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/createDataStoreTT?truetwinId=${truetwinId}`);
}
const getTrueTwinDataStoreFiles = (truetwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/getDataStoreTTFiles?truetwinId=${truetwinId}`);
}

const getTrueTwinDataStoreFilecontent = (truetwinId, fileName) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/getFileContentDataStoreTTFiles?truetwinId=${truetwinId}&fileName=${fileName}`);
}

const deleteFileTrueTwinDataStore = (truetwinId, fileType, fileName) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/deleteFileContentDataStoreTTFiles?truetwinId=${truetwinId}&FileType=${fileType}&fileName=${fileName}`);
}

const deleteTrueTwinDataStore = (truetwinId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/deleteDataStoreTT?truetwinId=${truetwinId}`);
}


const uploadScenarioSchedule = (scenarioId, trueTwinId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/uploadschedule?scenarioId=${scenarioId}&trueTwinId=${trueTwinId}`);
}

const getOrbitGrafanadata = (scenarioId, pageNo) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/ADCSTelemetry?scenarioId=${scenarioId}&pageId=${pageNo}`);
}

const postAdcsSdCardData = (body, flatsatId, groundstationId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/adcs_log/sd_card?flatSatId=${flatsatId}&groundStationId=${groundstationId}`, body);
}

const postUploadFileConsoleFlatSat = (missionId, truetwinId, scenario_id, fileId, lossDetection, mtu, delay, activityCheck, rxConnFailTimeout, desId, ftmFileId) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/fileUploadStart?missionId=${missionId}&truetwinId=${truetwinId}&scenarioId=${scenario_id}&fileId=${fileId}&lossDetection=${lossDetection}&mtu=${mtu}&delay=${delay}&activityCheck=${activityCheck}&rxConnFailTimeout=${rxConnFailTimeout}&destId=${desId}&ftmFileId=${ftmFileId}`);
}

const postUploadFileConsoleFlatSatTele = (formData) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/telemetryFromOut`, formData);
}

// NEW SIMULATION APIS //
const getScenarioOrbitParams = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/orbitparameters?scenarioId=${scenarioId}`);
}
const getOnBoardScheduleData = (simulationId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/simulation/onboardschedule?simulationId=${simulationId}`);
}
const getTrueTwinData = (trueTwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${trueTwinId}`);
}

const getScenarioData = (scenario_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario?scenarioId=${scenario_id}`);
}

const getSimulationStatus = (simulationId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/simulation/status?simulationId=${simulationId}`);
}

const getOribtData = (scenarioId, trueTwinId, propagation) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/orbit?scenarioId=${scenarioId}&trueTwinId=${trueTwinId}&propagation=${propagation}`);
}

const getnewOrbitData = (missionId, scenarioId, propagation) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/orbit?propagation=${propagation}`);
}

const getTimeBasedGroundContacts = (scenarioId, satelliteId, startTime, endTime, mode) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/scenario/${scenarioId}/satellite/${satelliteId}/contacts/time?startTime=${startTime}&endTime=${endTime}&mode=${mode}`);
}
const getUpcommingGroundContacts = (scenarioId, satelliteId, queryMode, startTime, endTime) => {
  if (queryMode === 'all') {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/scenario/${scenarioId}/satellite/${satelliteId}/contacts/upcoming?queryMode=${queryMode}`);
  } else {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/scenario/${scenarioId}/satellite/${satelliteId}/contacts/upcoming?queryMode=${queryMode}&startTime=${startTime}&endTime=${endTime}`);
  }
}
const getOperatedOrbit = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/operate/${scenarioId}/satelliteorbit`);
}
const getConfiguredGS = (missionId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/promotedsats/groundstations/${missionId}/${satelliteId}`);
}

const getGroundContacts = (missionId, scenarioId, satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/satellite/${satId}/contacts`);
}

const getGroundContactData = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/groundstations`);
}

const getSatelliteById = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satId}`,);
}

const getCommandDetailsById = (truetwinId, satelliteId, scenarioId, commandId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/comms/command?TruetwinId=${truetwinId}&SatelliteId=${satelliteId}&ScenarioId=${scenarioId}&CommandUid=${commandId}`);
};
const postCommandDetails = (data) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/comms/command`, data);
}

const getValidSessionId = (sessionId) => {
  if (sessionId && typeof sessionId === 'string' && sessionId.trim() !== '' && sessionId !== 'undefined' && sessionId !== 'null') {
    return sessionId.trim();
  }
  const stored = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('sessionId') : null;
  if (stored && typeof stored === 'string' && stored.trim() !== '' && stored !== 'undefined' && stored !== 'null') {
    return stored.trim();
  }
  const newId = uuidv4();
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem('sessionId', newId);
  }
  return newId;
};

const exportConsoleMessages = (satelliteId, truetwinId, scenarioId, sessionId, credentials) => {
  const validSessionId = getValidSessionId(sessionId);
  return (`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/consoleExport?SatelliteId=${satelliteId}&TruetwinId=${truetwinId}&ScenarioId=${scenarioId}&SessionId=${validSessionId}&cursor=&size=${0}&isRawByte=${false}&authToken=${credentials}`);
}
const getAllRawCommandDetails = (satelliteId, truetwinId, scenarioId, cursor, sessionId, payload) => {
  const validSessionId = getValidSessionId(sessionId);
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/comms/allCommands?SatelliteId=${satelliteId}&TruetwinId=${truetwinId}&LinkId&ScenarioId=${scenarioId}&SessionId=${validSessionId}&cursor=${cursor}&size=${50}&isRawByte=${true}`, payload);
}
// Operate Relatedd APIS //

const generateOperateSchedule = (payload) => {
  const { missionId, scenarioId, satelliteId, taskPlanId, startEpoch, duration, scheduleName } = payload;
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/operate/${scenarioId}/satellite/${satelliteId}/generateonboardschedule?taskPlanId=${taskPlanId}&startEpoch=${startEpoch}&duration=${duration}&scheduleName=${scheduleName}`);
}
const generateAdhocTaskSchedule = (payload) => {
  const {
    missionId,
    scenarioId,
    satelliteId,
    adhocTaskId,
    startEpoch,
    scheduleName,
  } = payload;
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/operate/${scenarioId}/satellite/${satelliteId}/generateadhoctaskschedule?adhocTaskId=${adhocTaskId}&startEpoch=${startEpoch}&scheduleName=${scheduleName}`);
};

const getOngoingSchedule = (scenarioId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/satellite/${satelliteId}/getongoingschedule`);
}
const getAllOnBoardSchedules = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/onboardschedule/all`);
}
const deleteOnboardSchedules = (scenarioId, scheduleId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/operate/${scenarioId}/onboardschedule/${scheduleId}`);
}

const postOperateTcCommand = (scenarioId, contactId, satelliteId, executeNow, payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/contact/${contactId}/satellite/${satelliteId}/execute/tc?executeNow=${executeNow}`, payload);
}

const postOperateAdhocTaskCommand = (contactId, taskId, scenarioId, truetwinId, executeNow) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/execute/task?contactId=${contactId}&taskId=${taskId}&scenarioId=${scenarioId}&truetwinId=${truetwinId}&executeNow=${executeNow}`);
}
const postOperateSetOBCTaskCommand = (contactId, scenarioId, truetwinId, executeNow) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/execute/setobctime?contactId=${contactId}&scenarioId=${scenarioId}&truetwinId=${truetwinId}&executeNow=${executeNow}`);
}
const postOperateScheduleTaskCommand = (scenarioId, payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/uploadschedule`, payload);
}
const importOperateSchedule = (missionId, scenarioId, satelliteId, payload, name) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/satellite/${satelliteId}/importschedule?scheduleName=${name}`, payload);
}
const postContact = (scenarioId, satelliteId, payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/scenario/${scenarioId}/satellite/${satelliteId}/contact`, payload);
}
const book_contact = (contactId, scenarioId) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/contact/book?contactId=${contactId}&scenarioId=${scenarioId}`);
}
const unbook_contact = (contactId, scenarioId) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/contact/unbook?contactId=${contactId}&scenarioId=${scenarioId}`);
}

const unbook_delete_contact = (contactId, scenarioId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/contact/unbookanddelete?contactId=${contactId}&scenarioId=${scenarioId}`);
}

const getContactDetails = (scenarioId, contactId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/contact?scenarioId=${scenarioId}&contactId=${contactId}`);
}

// Operate Relatedd APIS //
// NEW SIMULATION APIS //

//FILTER RELATED APIS //

const getCommandFilterOptions = (truetwinId, scenarioId, satId, missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/comms/filterList?truetwinId=${truetwinId}&scenarioId=${scenarioId}&satId=${satId}&missionId=${missionId}`);
}

const getCommandFilterOptionsForMda = (truetwinId, scenarioId, elementId, missionId,) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v2/groundstation/comms/filterList?missionId=${missionId}&truetwinId=${truetwinId}&scenarioId=${scenarioId}&elementId=${elementId}`);
}

const postConsoleFilterDetails = (satelliteId, truetwinId, scenarioId, cursor, sessionId, payload) => {
  const validSessionId = getValidSessionId(sessionId);
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/comms/allCommands?SatelliteId=${satelliteId}&TruetwinId=${truetwinId}&LinkId&ScenarioId=${scenarioId}&SessionId=${validSessionId}&cursor=${cursor}&size=${50}&isRawByte=${false}&tempSession=${false}`, payload);
}

const getCommandFilterGroups = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/test/scenario/${scenarioId}/filterGroups`);
}

const patchFilterGroups = (scenarioId, payload) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/test/scenario/${scenarioId}/filterGroups`, payload);
}

const deleteFilterGroup = (scenarioId, filterGroupId, requestId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/filterGroups/${filterGroupId}?requestId=${requestId}`);
}

//FILE TRANSFER MANAGEMENT APIS// --> GROUND FILES
const postFileToACP = ({ missionId, truetwinId, scenarioId, formData }) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/fileUploadStorage?missionId=${missionId}&truetwinId=${truetwinId}&scenarioId=${scenarioId}`, formData);
}

const getACPFiles = (missionId, scenarioId, truetwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/FtmFiles?missionId=${missionId}&scenarioId=${scenarioId}&truetwinId=${truetwinId}`)
}

const deleteACPFile = (missionId, scenarioId, truetwinId, id) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/fileUploadStorage?missionId=${missionId}&scenarioId=${scenarioId}&truetwinId=${truetwinId}&fileId=${id}`)
}

const getDestinationIds = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/comms/daList`)
}

const cancelUploadingGroundfile = (truetwin_id, fileId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/fileUploadcancel?truetwinId=${truetwin_id}&fileId=${fileId}`)
}

const pauseGroundFileTransfer = (truetwinId, fileId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/fileUploadSuspend?truetwinId=${truetwinId}&fileId=${fileId}`)
}

const resumeGroundFileTransfer = (truetwinId, fileId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/fileUploadResume?truetwinId=${truetwinId}&fileId=${fileId}`)
}

const downloadFromMinio = (missionId, scenarioId, truetwinId, fileId) => {
  return ApiService.getBlob(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/downloadMinioFile?missionId=${missionId}&scenarioId=${scenarioId}&trueTwinId=${truetwinId}&fileId=${fileId}`)
}

//FILE TRANSFER MANAGEMENT APIS// --> ONBOARD FILES
const refreshDownlinkQueue = (missionId, truetwinId, scenarioId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/${missionId}/onboard/${truetwinId}/list/${scenarioId}`);
}

const getOnboardFileList = (missionId, scenarioId, truetwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/${missionId}/onboard/${truetwinId}/getallonboardinfo/${scenarioId}`)
}

const getDownlinkQueue = (missionId, scenarioId, truetwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/${missionId}/onboard/${truetwinId}/list/${scenarioId}`)
}

const changePriority = (missionId, truetwinId, scenarioId, fileId, priority) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/${missionId}/onboard/${truetwinId}/priorityUpdate?scenarioId=${scenarioId}&fileId=${fileId}&priority=${priority}`)
}

const deleteDownlink = (missionId, truetwinId, scenarioId, fileId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/${missionId}/onboard/${truetwinId}/deleteFile?scenarioId=${scenarioId}&fileId=${fileId}`)
}

const getDownlinkHistory = (missionId, truetwinId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/${missionId}/onboard/${truetwinId}/getonboardfilehistory?scenarioId=${scenarioId}`)
}

const getLastRefreshTime = (truetwinId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/onboard/${truetwinId}/getLastRefreshTime`)
}

//--------------------------------------//

const getSupported_system_faults = (missionId, scenarioId, satgrpId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satgrpId}/faultdetails`,)
}
const post_inject = (
  missionId,
  scenarioId,
  faultScheduleId,
  payload
) => {
  const url = `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/faultschedule/${faultScheduleId}/addfault`;
  return ApiService.patch(url, payload);
};


const getInjectedFaultList = (
  missionId,
  scenarioId,
  satgrpId,
) => {
  const url = `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/satellitegroupId/${satgrpId}/faults:get`;
  return ApiService.get(url);
}

const cancelInjectedFault = (missionId, scenarioId, faultScheduleId, faultId) => {
  const url = `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/faultschedule/${faultScheduleId}/fault/${faultId}/cancel`;
  return ApiService.post(url);
};

const stopInjectedFault = (missionId, scenarioId, faultScheduleId, faultId) => {
  const url = `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/faultschedule/${faultScheduleId}/fault/${faultId}/stop`;
  return ApiService.post(url);
};

// ONBOARD SCHEDULE APIs
const generateOnboardSchedule = (payload, missionId, scenarioId, satelliteId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/operate/${scenarioId}/satellite/${satelliteId}/generateonboardschedule`, payload);
}

const onboardScheduleAddTask = (payload, missionId, scenarioId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/mission/${missionId}/scenario/${scenarioId}/schedule/addTask`, payload);
}

const onboardScheduleAddCommand = (payload, missionId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/mission/${missionId}/schedule/addCommand`, payload);
}

const validateScheduleData = (payload, missionId, scenarioId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/mission/${missionId}/scenario/${scenarioId}/onboardschedule/validate`, payload)
}

const saveScheduleData = (payload, missionId, scenarioId, satelliteId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/mission/${missionId}/scenario/${scenarioId}/satellite/${satelliteId}/onboardschedule/save`, payload)
}

const saveEditedSchedule = (payload, missionId, scenarioId, satelliteId, scheduleId) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v1/mission/${missionId}/scenario/${scenarioId}/satellite/${satelliteId}/schedule/${scheduleId}/onboardschedule/save`, payload)
}

//////////// SECURITY CONFIG APIS ////////////

const getSecurityConfig = (satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/getTTCKeys?satelliteId=${satelliteId}`);
}

const updateAllSecurityConfig = (satelliteId, payload) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/addTTCKeys?satelliteId=${satelliteId}`, payload);
}

const uploadSecurityConfig = (contactId, scenarioId, truetwinId, executeNow, payload) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/execute/updatettckeysTask?contactId=${contactId}&scenarioId=${scenarioId}&truetwinId=${truetwinId}&executeNow=${executeNow}`, payload);
}

const activateSecurityConfig = (contactId, scenarioId, truetwinId, executeNow, payload) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/execute/activatettckeysTask?contactId=${contactId}&scenarioId=${scenarioId}&truetwinId=${truetwinId}&executeNow=${executeNow}`, payload);
}

const CommandCenterService = {
  createTrueTwin,
  deployTrueTwin,
  unDeployTrueTwin,
  getAllTrueTwins,
  get_TrueTwins_by_satId,
  postJSONCommand,
  getJSONResponse,
  delete_TrueTwin,
  getObject,
  getRemoteConfigData,
  connectGroundStation,
  removeGroundStation,
  runSequence,
  disconnectGroundStation,
  delete_Task,
  delete_Schedule,
  downloadSessionLogs,
  createConsoleSession,
  removeConsoleSession,
  getConsoleSessionLogs,
  deleteConsoleSessionLogs,
  createDataStoreTT,
  getTrueTwinDataStoreFiles,
  getTrueTwinDataStoreFilecontent,
  deleteFileTrueTwinDataStore,
  deleteTrueTwinDataStore,
  uploadScenarioSchedule,
  getOrbitGrafanadata,
  postAdcsSdCardData,
  postUploadFileConsoleFlatSat,
  postUploadFileConsoleFlatSatTele,

  // NEW SIMULATION APIS //
  getOribtData,
  getOperatedOrbit,
  getnewOrbitData,
  getTrueTwinData,
  getScenarioData,
  getGroundContacts,
  getGroundContactData,
  getSimulationStatus,
  getScenarioOrbitParams,
  getOnBoardScheduleData,
  getSatelliteById,
  getCommandDetailsById,
  postCommandDetails,
  generateOperateSchedule,
  generateAdhocTaskSchedule,
  getOngoingSchedule,
  getAllOnBoardSchedules,
  deleteOnboardSchedules,
  // NEW SIMULATION APIS //

  // Operate Console APIS //
  getConfiguredGS,
  getAllRawCommandDetails,
  getUpcommingGroundContacts,
  getTimeBasedGroundContacts,
  postOperateTcCommand,
  postOperateScheduleTaskCommand,
  postOperateSetOBCTaskCommand,
  postOperateAdhocTaskCommand,
  importOperateSchedule,
  exportConsoleMessages,
  postContact,
  getContactDetails,
  book_contact,
  unbook_contact,
  unbook_delete_contact,
  // Operate Console APIS //
  //FILTER APIS //
  getCommandFilterOptions,
  getCommandFilterOptionsForMda,
  postConsoleFilterDetails,
  getCommandFilterGroups,
  patchFilterGroups,
  deleteFilterGroup,
  //faultinjection Apis//
  getSupported_system_faults,
  post_inject,
  getInjectedFaultList,
  cancelInjectedFault,
  stopInjectedFault,
  // Operate Console APIS //
  postFileToACP,
  getACPFiles,
  deleteACPFile,
  getDestinationIds,
  cancelUploadingGroundfile,
  pauseGroundFileTransfer,
  resumeGroundFileTransfer,
  downloadFromMinio,
  refreshDownlinkQueue,
  getOnboardFileList,
  getDownlinkQueue,
  changePriority,
  deleteDownlink,
  getDownlinkHistory,
  getLastRefreshTime,

  // ONBOARD SCHEDULE APIs
  generateOnboardSchedule,
  onboardScheduleAddTask,
  onboardScheduleAddCommand,
  validateScheduleData,
  saveEditedSchedule,
  saveScheduleData,

  // SECURITY CONFIG APIS //
  getSecurityConfig,
  updateAllSecurityConfig,
  uploadSecurityConfig,
  activateSecurityConfig,
};
export default CommandCenterService;
